module.exports = __webpack_public_path__ + "img/Noelia_Rycerz.54e9025c.png";